import { toast } from "react-toastify";

export const userDoesNotExistWarning = () => toast.error(
    "This email is not registered. Please register through the app first.",
    {
        autoClose: 5000,
    }
);
